var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRubbishBin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    draggable: "false",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M19.8488 2.82597H16.6443V0.743651C16.6443 0.324509 16.3062 0 15.8871 0C15.8464 0 15.8193 0.0135767 15.8061 0.0271225C15.7925 0.0135767 15.7654 0 15.7518 0H8.22056H8.16663H8.11238C7.69327 0 7.36876 0.324509 7.36876 0.743651V2.82601H4.15077C3.23118 2.82601 2.51465 3.54253 2.51465 4.46213V5.65201V6.13928C2.51465 6.69157 2.96236 7.13928 3.51465 7.13928H3.93441V22.3775C3.93441 23.2971 4.63739 24 5.55698 24H18.4426C19.3622 24 20.0787 23.2971 20.0787 22.3775V7.13928H20.4849C21.0372 7.13928 21.4849 6.69157 21.4849 6.13928V5.65201V4.46213C21.4849 3.54253 20.7681 2.82597 19.8488 2.82597ZM8.85604 1.48727H15.1435V2.82597H8.85604V1.48727ZM18.5778 22.3775C18.5778 22.4724 18.5372 22.5127 18.4426 22.5127H5.55698C5.46238 22.5127 5.42171 22.4723 5.42171 22.3775V7.13925H18.5778V22.3775ZM19.9841 5.65198H4.01547V4.46209C4.01547 4.36746 4.05613 4.31325 4.15074 4.31325H19.8488C19.9434 4.31325 19.9841 4.36746 19.9841 4.46209V5.65198Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 20.5V15.5C15 15.2239 14.7761 15 14.5 15C14.2239 15 14 15.2239 14 15.5V20.5C14 20.7761 14.2239 21 14.5 21C14.7761 21 15 20.7761 15 20.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 20.5V9.5C10 9.22386 9.77614 9 9.5 9C9.22386 9 9 9.22386 9 9.5V20.5C9 20.7761 9.22386 21 9.5 21C9.77614 21 10 20.7761 10 20.5Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", null, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRubbishBin);
export default __webpack_public_path__ + "static/media/rubbish-bin.e4175f06.svg";
export { ForwardRef as ReactComponent };